//let uatUrl = '/richin/uat'; // uat环境
let uatUrl = 'http://110.41.7.145:28088'; // uat环境
export { uatUrl };
